import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { ServicePreviewRow } from '../model/types';
import ServicesTransferTableBody from './ServicesTransferTableBody';

interface ServicesTransferTableProps {
    rows: ServicePreviewRow[];
    mode?: 'preview' | 'result';
    onToggle?: (key: string) => void;
}

const ServicesTransferTable = ({
    rows,
    mode = 'preview',
    onToggle,
}: ServicesTransferTableProps) => {
    const { t } = useTranslation(['Objects']);
    const ns = 'documents.proposal2Warehouse';

    return (
        <div className="proposal2warehouse-table-wrap px-3 mb-3">
            <h6 className="text-muted mb-2">{t(`${ns}.servicesTitle`)}</h6>
            <Table size="sm" className="Proposal2WarehouseTable table-hover mb-0 align-middle">
                <thead>
                    <tr className="bg-light">
                        {mode === 'preview' ? <td className="head-check" /> : null}
                        <td className="head-name">{t(`${ns}.colService`)}</td>
                        <td className="head-count text-end">{t(`${ns}.colCount`)}</td>
                        <td className="head-team">{t(`${ns}.colTeam`)}</td>
                        {mode === 'result' ? (
                            <td className="head-status">{t(`${ns}.colStatus`)}</td>
                        ) : null}
                    </tr>
                </thead>
                <ServicesTransferTableBody
                    rows={rows}
                    mode={mode}
                    emptyLabel={t(`${ns}.emptyServices`)}
                    colService={t(`${ns}.colService`)}
                    colCount={t(`${ns}.colCount`)}
                    colTeam={t(`${ns}.colTeam`)}
                    statusOk={t(`${ns}.statusOk`)}
                    statusFail={t(`${ns}.statusFail`)}
                    onToggle={onToggle}
                />
            </Table>
        </div>
    );
};

export default ServicesTransferTable;
